import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import {getData} from '../../../../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined } from '@ant-design/icons';

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}


class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			school_list : [],
			academic_year_ : [],
			coupons_list : [],
			marketing_followup_details : [],
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			timeline: false,
			academic_year: '',
			amount: '',
			class: '',
			category_name: '',
			coupon_name: '',
			coupon_amount: '',
			details: '',
			valid_till: '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.onChange_valid_till = this.onChange_valid_till.bind(this);
		this.onChange_enddate = this.onChange_enddate.bind(this);
		this.change_year = this.change_year.bind(this);
		this.change_section = this.change_section.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {id : this.props.match.params.id,user_id:user_id}
			getData('fees/get_concession_coupons_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							coupons_list: result['data'],
							academic_year: result['data'][0]['academic_year'],
							coupon_name: result['data'][0]['coupon_name'],
							coupon_amount: result['data'][0]['coupon_amount'],
							valid_till: result['data'][0]['valid_till'],
							details: result['data'][0]['details'],
						});
					}else{
						this.setState({
							coupons_list: [],
						});
					}
				}
			});
			
	}
  }
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		var app = {
		    id : this.props.match.params.id,
			school_id : storedArray['data'][0]['school_id'],
			user_id : storedArray['data'][0]['user_id'],
			academic_year : this.state.academic_year,
			coupon_name : this.state.coupon_name,
			coupon_amount : this.state.coupon_amount,
			valid_till : this.state.valid_till,
			details : this.state.details,
		}
		getData('fees/update_concession_coupons',app).then((result) => {
		if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Concession Coupons Updated',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
              window.location.href = '/settings/fees/concession-coupons';
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
  
  
  onChangechecked(checkedValues) {
	  this.setState({ checked_id: this.state.checked_id.concat(checkedValues) });
	}	
	
	onChange_valid_till(date, dateString) {
	  this.setState({ valid_till: dateString, });
	}
	
	onChange_enddate(date, dateString) {
	  this.setState({ end_date: dateString, });
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};
	
	change_year(event){
         this.setState({academic_year: event});
     }
	
	change_section(event){
         this.setState({class: event});
     }

	render() {
	
	var lenght = this.state.school_list.length; 
	
	
		return (
			<div class="mobile_view">
				<div id="main" class="bg-off">
					<div class="row">
						<div class="col col-md-12  ex-padd">
							<div id="breadcrumbs-wrapper" class="bg-off">
							   <div>
								  <div class="row no-margin">
									  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
										  <div class="col s12 m6 l6 pt-10 pb-15 ">
												<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Concession Coupons - Update</span></h5>
											 </div>
											 <div class="col s12 m6 l6 right-align-md pt-10">
												<ol class="breadcrumbs mb-0">
												   <li class="breadcrumb-item"><a href="/">Home</a></li>
												   <li class="breadcrumb-item"><a href="/settings/fees">Fees Setting</a></li>
												   <li class="breadcrumb-item"><a href="/settings/fees/concession-coupons">Concession Coupons</a></li>
												   <li class="breadcrumb-item active">Update</li>
												</ol>
											 </div> 
										 </div>
									  </div>
							   </div>
							</div>
						</div>
						<div class="col col-md-12  ex-padd enquiry bg-off">
			
							{this.state.coupons_list.map((list)=>(
							<div class="container">
								
								<div class="col col-md-12  mb-20 card-content iq-card view-Profile">
									<section class="invoice-list-wrapper section receipt">
										
										<div class="col m12 s12 pl-0">
											<div class="col m4 s12 pb-20">
													<label>Academic Year</label>
													<Select onChange={this.change_year} defaultValue={this.state.academic_year}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
													</Select>
											</div>	
											<div class="col m4 s12">
												<label>Coupon Name</label>
												<input type="text" name="coupon_name" onChange={this.handleSizeChange} defaultValue={this.state.coupon_name}  />
											</div>	
											<div class="col m4 s12 pb-20">
												<label>Coupon Amount</label>
												<input type="number" step="any" name="coupon_amount" onChange={this.handleSizeChange} defaultValue={this.state.coupon_amount}  />
											</div>
										</div>
										
										
										<div class="col m12 s12 pl-0">
											<div class="col m4 s12 pb-20">
												<label>Valid Till </label>
												<DatePicker onChange={this.onChange_valid_till} name="valid_till"  defaultValue={moment(list.valid_till, 'YYYY-MM-DD')}  id="valid_till"   />
											</div>	
											<div class="col m4 s12">
												<label>Details</label>
												<TextArea
												  placeholder=""
												  autoSize={{ minRows: 2, maxRows: 6 }}
												  onChange={this.handleSizeChange} 
												  name="details" defaultValue={this.state.details}
												/>
											</div>	
										</div>

																		
								<div class="col m12 s12 meal  mb-20 center">
									 <Button className="snd-btn btn-lg large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Update</Button>
								</div>
						
										
										
									</section>
								</div>
								
								
							</div>	

							))}
						</div>
           
					</div>
				</div>
			</div>
		) 
	} 
}
export default Index;
